import { Check } from '@casumo/dojo-react-icons';
import classNames from 'classnames';
import { memo } from 'react';

export type ValidationRule = {
  id: string;
  label: string;
  isValid: boolean;
};

type ValidationRuleItemProps = {
  rule: ValidationRule;
  animate?: boolean;
};

export const ValidationRuleItem = memo(({ rule, animate }: ValidationRuleItemProps) => (
  <li
    className={classNames(
      'flex items-center gap-2xs text-grey-90',
      animate && 'transition-all duration-300 animate-fadeIn',
    )}
    data-testid={`registration-password-rule-${rule.id}`}
    data-valid={rule.isValid}
  >
    <span
      className={classNames(
        'flex items-center justify-center rounded-full',
        rule.isValid
          ? 'bg-green-30 text-white border-green-30 border w-sm h-sm animate-bounceCheck'
          : 'w-sm h-sm border border-grey-35',
      )}
    >
      {rule.isValid && (
        <Check className="w-2.5 h-3.5" />
      )}
    </span>
    <span className="text-body-xs font-circular-pro">{rule.label}</span>
  </li>
));

ValidationRuleItem.displayName = 'ValidationRuleItem';
